import React, { useState } from 'react';
import { Button, Alert, message } from 'antd';
import { ReloadOutlined, ClockCircleOutlined, CopyOutlined, CheckOutlined } from '@ant-design/icons';
import logo2 from '../ulrc_logo.png';
import court from '../image_ug.png';

function MaintenancePage() {
  const [showEmail, setShowEmail] = useState(false);
  const [copied, setCopied] = useState(false);
  
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleContactSupport = () => {
    if (!showEmail) {
      setShowEmail(true);
    } else {
      // Copy email to clipboard
      navigator.clipboard.writeText('ulrc@ulrc.go.ug').then(() => {
        setCopied(true);
        message.success('Email copied to clipboard!');
        setTimeout(() => {
          setCopied(false);
          setShowEmail(false); // Reset to original state
        }, 2000);
      }).catch(() => {
        message.error('Failed to copy email');
      });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Logo Section */}
          <div className="mb-6">
            <div className="flex gap-4 justify-center items-center mb-6">
              <img src={logo2} alt="ULRC Logo" className="h-12 w-auto" />
              {/* <img src={court} alt="Uganda Coat of Arms" className="h-12 w-auto" /> */}
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            System Under Maintenance
          </h1>

          {/* Subtitle */}
          <h2 className="text-lg text-blue-600 font-semibold mb-6">
            Uganda Law Reform Commission
          </h2>

          {/* Description */}
          <p className="text-gray-600 text-lg mb-6 leading-relaxed">
            We're currently performing scheduled maintenance to improve your experience. 
            Our legal database will be back online shortly.
          </p>

          {/* Status Alert */}
          <Alert
            message="Maintenance in Progress"
            description="Our team is working to enhance the system. Thank you for your patience."
            type="info"
            icon={<ClockCircleOutlined />}
            className="mb-6 text-left"
            showIcon
          />

          {/* Action Buttons */}
          <div className="space-y-3">
            <Button 
              size="large" 
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              className="w-full h-12 text-base font-medium rounded-lg bg-blue-600 hover:bg-blue-700 text-white hover:text-white border-none"
            >
              Check Again
            </Button>
            
            <Button 
              type="default" 
              size="large" 
              className="w-full h-12 text-base font-medium rounded-lg border-blue-200 text-blue-600 hover:border-blue-400 hover:text-blue-700"
              onClick={handleContactSupport}
              icon={showEmail ? (copied ? <CheckOutlined /> : <CopyOutlined />) : null}
            >
              {showEmail ? (copied ? 'Copied!' : 'ulrc@ulrc.go.ug (Click to Copy)') : 'Contact Support'}
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Uganda Law Reform Commission. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs mt-1">
            Modernising the Law
          </p>
        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;